module.exports = __webpack_public_path__ + "static/img/img13.f04912e4.png";